/* tslint:disable */
import { MinMax } from './min-max';

/**
 */
export class ViewMinMaxEquipment {
    mmPrice?: MinMax;
    mmLInterval?: MinMax;
    mmWInterval?: MinMax;
    mmVolume?: MinMax;
    mmShelvesL?: MinMax;
    mmShelvesW?: MinMax;
    mmShelvesNb?: MinMax;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-min-max-equipment.ts